import React from 'react';

import SelectionField from './SelectionField';

const DropdownSelectionField = ({

  disabled,

  fieldId,
  fieldIdentifier,
  fieldPositionId,
  displayType,
  targetValue,

  value,

  onChange,
  onFocus,

  //SDK Styles
  primaryColor,

  //Styles
  fontColor,
  borderWidth,
  borderColor,
  borderRadius,
  backgroundColor,

}) => {

  const handleChange = () => {

    const nextValue = value === targetValue ? '' : targetValue;

    if (onFocus) onFocus(fieldId, fieldIdentifier, fieldPositionId, {});
    if (onChange) onChange(fieldId, fieldIdentifier, fieldPositionId, nextValue);

  };

  return (
    <SelectionField
      {...{

        id: fieldPositionId,

        value: value === targetValue,
        disabled,
        displayType,
        onChange: handleChange,

        primaryColor,
        fontColor,
        borderColor,
        borderRadius,
        borderWidth,
        backgroundColor,
      }}
    />
  );

};

export default DropdownSelectionField;
